"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TraceChartTooltipSk", {
    enumerable: true,
    get: function() {
        return TraceChartTooltipSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _json = require("../json");
const _paramtools = require("../paramtools");
const _anomaly = require("../common/anomaly");
require("../commit-range-sk/commit-range-sk");
require("../json-source-sk/json-source-sk");
require("../triage-menu-sk/triage-menu-sk");
require("../point-links-sk/point-links-sk");
require("../user-issue-sk/user-issue-sk");
require("../pinpoint-dialog-sk/pinpoint-dialog-sk");
require("../../../elements-sk/modules/icons/close-icon-sk");
const _triageapi = require("../anomalies-table-sk/triage-api");
const _cid = require("../cid/cid");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _TraceChartTooltipSk;
let TraceChartTooltipSk = (_TraceChartTooltipSk = class TraceChartTooltipSk extends _lit.LitElement {
    connectedCallback() {
        super.connectedCallback();
        const stopPropagation = (e)=>e.stopPropagation();
        const events = [
            'pointerdown',
            'pointermove',
            'pointerup',
            'click',
            'dblclick',
            'wheel',
            'mousedown',
            'mouseup'
        ];
        events.forEach((event)=>{
            this._handlers[event] = stopPropagation;
            this.addEventListener(event, stopPropagation);
        });
    }
    disconnectedCallback() {
        Object.keys(this._handlers).forEach((event)=>{
            this.removeEventListener(event, this._handlers[event]);
        });
        super.disconnectedCallback();
    }
    _formatDate(ts) {
        if (!ts || ts === Infinity || ts === -Infinity) return '';
        const date = ts > 1e11 ? new Date(ts) : new Date(ts * 1000);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    }
    _formatYValue(val) {
        if (val === undefined || val === null || isNaN(val)) {
            return 'N/A';
        }
        const label = this.yAxisLabel.toLowerCase();
        if (label.includes('bytes') || label.includes('sizeinbytes')) {
            const absVal = Math.abs(val);
            if (absVal >= 1024 * 1024 * 1024) return (val / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
            if (absVal >= 1024 * 1024) return (val / (1024 * 1024)).toFixed(2) + ' MB';
            if (absVal >= 1024) return (val / 1024).toFixed(2) + ' KB';
            return val.toFixed(0) + ' B';
        }
        if (label.includes('bytespersecond')) {
            const absVal = Math.abs(val);
            if (absVal >= 1024 * 1024 * 1024) return (val / (1024 * 1024 * 1024)).toFixed(2) + ' GB/s';
            if (absVal >= 1024 * 1024) return (val / (1024 * 1024)).toFixed(2) + ' MB/s';
            if (absVal >= 1024) return (val / 1024).toFixed(2) + ' KB/s';
            return val.toFixed(0) + ' B/s';
        }
        if (label.includes('n%') || label.includes('%')) {
            return val.toFixed(2) + '%';
        }
        if (label.includes('ms')) {
            const absVal = Math.abs(val);
            if (absVal >= 1000) return (val / 1000).toFixed(2) + ' s';
            return val.toFixed(2) + ' ms';
        }
        if (label.includes('ns')) {
            const absVal = Math.abs(val);
            if (absVal >= 1e6) return (val / 1e6).toFixed(2) + ' ms';
            if (absVal >= 1e3) return (val / 1e3).toFixed(2) + ' µs';
            return val.toFixed(0) + ' ns';
        }
        if (Math.abs(val) >= 1000000) return val.toExponential(2);
        if (Math.abs(val) < 0.01 && val !== 0) return val.toExponential(2);
        return val.toFixed(2);
    }
    _formatTooltipValue(val) {
        if (val === undefined || val === null || isNaN(val)) {
            return 'N/A';
        }
        const formatted = this._formatYValue(val);
        const rawStr = val.toFixed(4);
        const rawStrStripped = rawStr.replace(/\.?0+$/, '');
        if (!formatted.includes(rawStrStripped)) {
            return `${formatted} (${rawStr})`;
        }
        return formatted;
    }
    _anomalyChange(regression) {
        const change = (0, _anomaly.formatPercentage)((0, _anomaly.getPercentChange)(regression.median_before, regression.median_after));
        const divClass = regression.is_improvement ? 'improvement' : 'regression';
        return (0, _lit.html)`<span class="${divClass}">${change}</span>`;
    }
    updated(changedProperties) {
        if (changedProperties.has('hoveredPoint')) {
            if (this._debounceTimer) {
                window.clearTimeout(this._debounceTimer);
                this._debounceTimer = null;
            }
            if (this.hoveredPoint) {
                this._debounceTimer = window.setTimeout(()=>{
                    this._loadTooltipData();
                }, 150);
            }
        }
    }
    _getCommitRangeKeys() {
        var _window_perf;
        var _window_perf_keys_for_commit_range;
        return (_window_perf_keys_for_commit_range = (_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.keys_for_commit_range) !== null && _window_perf_keys_for_commit_range !== void 0 ? _window_perf_keys_for_commit_range : [
            'V8',
            'WebRTC',
            'V8 Git Hash',
            'WebRTC Git Hash'
        ];
    }
    _getUsefulLinksKeys() {
        var _window_perf;
        var _window_perf_keys_for_useful_links;
        return (_window_perf_keys_for_useful_links = (_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.keys_for_useful_links) !== null && _window_perf_keys_for_useful_links !== void 0 ? _window_perf_keys_for_useful_links : [
            'Build Page',
            'Tracing uri',
            'Browser Version',
            'Workflow',
            'Swarming Tasks'
        ];
    }
    _loadTooltipData() {
        if (!this.hoveredPoint) return;
        const commit = this.hoveredPoint.row.commit_number;
        const traceName = this.hoveredPoint.series.id;
        if (!this._lastLoadedPoint || this._lastLoadedPoint.commit !== commit || this._lastLoadedPoint.traceName !== traceName) {
            var _this_shadowRoot, _this_shadowRoot1, _this_regressions_traceName;
            this._lastLoadedPoint = {
                commit,
                traceName
            };
            this._debouncedTraceKey = this.hoveredPoint.series.originalId || traceName;
            this._debouncedCommitPosition = commit;
            const s = this.hoveredPoint.series;
            const i = s.rows.findIndex((r)=>r.commit_number === commit);
            const prevCommit = i > 0 && s.rows[i - 1].commit_number > 0 ? s.rows[i - 1].commit_number : commit;
            const prevRow = i > 0 ? s.rows[i - 1] : null;
            if (!this.hoveredPoint.row.author || !this.hoveredPoint.row.message || !this.hoveredPoint.row.hash || prevRow && !prevRow.hash) {
                (0, _cid.lookupCids)([
                    (0, _json.CommitNumber)(prevCommit),
                    (0, _json.CommitNumber)(commit)
                ]).then((resp)=>{
                    if (resp && resp.commitSlice) {
                        resp.commitSlice.forEach((c)=>{
                            if (c.offset === commit) {
                                this.hoveredPoint.row.author = c.author;
                                this.hoveredPoint.row.message = c.message;
                                this.hoveredPoint.row.hash = c.hash;
                                this.hoveredPoint.row.url = c.url;
                            }
                            if (prevRow && c.offset === prevCommit) {
                                prevRow.author = c.author;
                                prevRow.message = c.message;
                                prevRow.hash = c.hash;
                                prevRow.url = c.url;
                            }
                        });
                        if (this.hoveredPoint && this.hoveredPoint.row.commit_number === commit) {
                            this._lastLoadedPoint = null;
                            this.requestUpdate();
                        }
                    }
                }).catch(console.error);
            }
            const pointLinks = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector('#tooltip-point-links');
            if (pointLinks) {
                const metadata = this.hoveredPoint.row.metadata;
                window.clearTimeout(this._linksTimeout);
                if (metadata && Object.keys(metadata).length > 0) {
                    pointLinks.displayUrls = metadata;
                    pointLinks.displayTexts = {};
                    pointLinks.commitPosition = commit;
                } else {
                    this._linksLoading = true;
                    this._linksTimeout = window.setTimeout(()=>{
                        if (!this.hoveredPoint) return;
                        const cleanTraceName = this.hoveredPoint.series.originalId || traceName;
                        const prevCommitPos = i > 0 ? s.rows[i - 1].commit_number : null;
                        pointLinks.load(commit, prevCommitPos, cleanTraceName, this._getCommitRangeKeys(), this._getUsefulLinksKeys(), []).then(()=>{
                            this._linksLoading = false;
                        }).catch((err)=>{
                            console.error(err);
                            this._linksLoading = false;
                        });
                    }, 100);
                }
            }
            const commitRangeSk = (_this_shadowRoot1 = this.shadowRoot) === null || _this_shadowRoot1 === void 0 ? void 0 : _this_shadowRoot1.querySelector('#tooltip-commit-range-link');
            if (commitRangeSk) {
                var _prevRow, _this_hoveredPoint;
                const hashes = [];
                if ((_prevRow = prevRow) === null || _prevRow === void 0 ? void 0 : _prevRow.hash) {
                    hashes.push(prevRow.hash);
                }
                if ((_this_hoveredPoint = this.hoveredPoint) === null || _this_hoveredPoint === void 0 ? void 0 : _this_hoveredPoint.row.hash) {
                    hashes.push(this.hoveredPoint.row.hash);
                }
                console.log('DEBUG hashes length:', hashes.length, hashes);
                console.log('DEBUG prevCommit:', prevCommit, 'commit:', commit);
                commitRangeSk.commitIndex = -1;
                commitRangeSk['_commitIds'] = [
                    prevCommit,
                    commit
                ];
                commitRangeSk['updateText']();
                if (hashes.length === 2) {
                    this._tooltipHashes = hashes;
                    commitRangeSk.hashes = hashes;
                    commitRangeSk.autoload = false;
                    commitRangeSk.recalcLink();
                } else {
                    console.log('DEBUG falling back to autoload');
                    this._tooltipHashes = null;
                    commitRangeSk.autoload = true;
                    commitRangeSk.recalcLink();
                }
            }
            const regression = (_this_regressions_traceName = this.regressions[traceName]) === null || _this_regressions_traceName === void 0 ? void 0 : _this_regressions_traceName[commit];
            if (regression) {
                var _this_shadowRoot2, _window_perf;
                const anomalyRangeSk = (_this_shadowRoot2 = this.shadowRoot) === null || _this_shadowRoot2 === void 0 ? void 0 : _this_shadowRoot2.querySelector('#anomaly-commit-range-link');
                if (anomalyRangeSk) {
                    const prev_commit = regression.start_revision - 1;
                    const end_commit = regression.end_revision;
                    anomalyRangeSk.setRange(prev_commit, end_commit);
                }
                const anomalyData = {
                    anomaly: regression,
                    x: i,
                    y: this.hoveredPoint.row.val,
                    highlight: false
                };
                this._nudgeList = this.calculateNudgeListSparse(s.rows, i, anomalyData, 2, 0, !((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.fetch_anomalies_from_sql));
            } else {
                this._nudgeList = null;
            }
        }
    }
    calculateNudgeListSparse(rows, currentIndex, anomalyData, nudgeRange = 2, xOffset = 0, isLegacy = true) {
        const nudgeList = [];
        const length = rows.length;
        if (currentIndex < 0 || currentIndex >= length) {
            return nudgeList;
        }
        for(let i = -nudgeRange; i <= nudgeRange; i++){
            const targetIndex = currentIndex + i;
            if (targetIndex >= 0 && targetIndex < length) {
                const prevValidIndex = targetIndex > 0 ? targetIndex - 1 : null;
                let start_revision = rows[targetIndex].commit_number;
                if (isLegacy && prevValidIndex !== null) {
                    start_revision = rows[prevValidIndex].commit_number + 1;
                } else if (!isLegacy) {
                    start_revision = anomalyData.anomaly.start_revision;
                }
                nudgeList.push({
                    display_index: i,
                    anomaly_data: anomalyData,
                    selected: i === 0,
                    start_revision: start_revision,
                    end_revision: rows[targetIndex].commit_number,
                    display_commit_number: rows[targetIndex].commit_number,
                    x: targetIndex - xOffset,
                    y: rows[targetIndex].val
                });
            }
        }
        return nudgeList;
    }
    getLastSubtest(d) {
        return d.subtest_7 || d.subtest_6 || d.subtest_5 || d.subtest_4 || d.subtest_3 || d.subtest_2 || d.subtest_1 || '';
    }
    constructTestPath(traceName) {
        const params = (0, _paramtools.fromKey)(traceName);
        const story = this.getLastSubtest(params);
        const parts = [];
        if (params.master) parts.push(params.master);
        if (params.bot) parts.push(params.bot);
        if (params.benchmark) parts.push(params.benchmark);
        if (params.test) parts.push(params.test);
        if (params.subtest_1 && params.subtest_1 !== story) parts.push(params.subtest_1);
        if (params.subtest_2 && params.subtest_2 !== story) parts.push(params.subtest_2);
        if (params.subtest_3 && params.subtest_3 !== story) parts.push(params.subtest_3);
        if (params.subtest_4 && params.subtest_4 !== story) parts.push(params.subtest_4);
        parts.push(story);
        return {
            testPath: parts.join('/'),
            story
        };
    }
    openBisectDialog() {
        var _this_regressions_s_id, _regression, _this_shadowRoot;
        if (!this.hoveredPoint) return;
        const s = this.hoveredPoint.series;
        const r = this.hoveredPoint.row;
        const traceName = s.id;
        const { testPath, story } = this.constructTestPath(traceName);
        const i = s.rows.indexOf(r);
        const prevCommit = i > 0 ? s.rows[i - 1].commit_number : r.commit_number;
        const regression = (_this_regressions_s_id = this.regressions[s.id]) === null || _this_regressions_s_id === void 0 ? void 0 : _this_regressions_s_id[r.commit_number];
        const bugId = ((_regression = regression) === null || _regression === void 0 ? void 0 : _regression.bugs) && regression.bugs.length > 0 ? String(regression.bugs[0].bug_id) : '';
        const anomalyId = regression ? String(regression.id) : '';
        const preloadInputs = {
            testPath: testPath,
            startCommit: String(prevCommit),
            endCommit: String(r.commit_number),
            bugId: bugId,
            anomalyId: anomalyId,
            story: story
        };
        const pinpointDialog = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector('#pinpoint-dialog-sk');
        if (pinpointDialog) {
            pinpointDialog.open('bisect', preloadInputs);
        }
    }
    openTryJobDialog() {
        var _this_shadowRoot;
        if (!this.hoveredPoint) return;
        const s = this.hoveredPoint.series;
        const r = this.hoveredPoint.row;
        const traceName = s.id;
        const { testPath, story } = this.constructTestPath(traceName);
        const i = s.rows.indexOf(r);
        const prevCommit = i > 0 ? s.rows[i - 1].commit_number : r.commit_number;
        const params = (0, _paramtools.fromKey)(traceName);
        const preloadInputs = {
            testPath: testPath,
            baseCommit: String(prevCommit),
            endCommit: String(r.commit_number),
            story: story,
            configuration: params.bot || '',
            benchmark: params.benchmark || ''
        };
        const pinpointDialog = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector('#pinpoint-dialog-sk');
        if (pinpointDialog) {
            pinpointDialog.open('try', preloadInputs);
        }
    }
    unassociateBug(traceName, regression) {
        (0, _triageapi.makeEditAnomalyRequest)([
            regression
        ], [
            traceName
        ], 'RESET').then(()=>{
            this.dispatchEvent(new CustomEvent('anomaly-changed', {
                bubbles: true,
                composed: true,
                detail: {
                    traceNames: [
                        traceName
                    ],
                    editAction: 'RESET',
                    anomalies: [
                        regression
                    ]
                }
            }));
            this.requestUpdate();
        });
    }
    _xAccessor(r) {
        return this.dateMode ? r.createdat : r.commit_number;
    }
    render() {
        var _window_perf;
        if (!this.hoveredPoint) return (0, _lit.html)``;
        const s = this.hoveredPoint.series;
        const r = this.hoveredPoint.row;
        return (0, _lit.html)`
      <div
        class="hover-tooltip"
        style="${this.hoveredPoint.y > this.canvasHeight / 2 ? `bottom: ${this.canvasHeight - this.hoveredPoint.y + 10}px;` : `top: ${this.hoveredPoint.y + 10}px;`} ${this.canvasWidth > 0 && this.hoveredPoint.x > this.canvasWidth / 2 ? `right: ${this.canvasWidth - this.hoveredPoint.x + 10}px;` : `left: ${this.hoveredPoint.x + 10}px;`}">
        <div class="color-indicator" style="background-color: ${s.color};"></div>
        <!-- Section 1: Point Info -->
        <div class="tooltip-section">
          <div class="tooltip-row">
            <strong>Series:</strong>${this.diffNamesMap.get(s.id) || s.id}
          </div>
          ${r.createdat ? (0, _lit.html)`
                <div class="tooltip-row">
                  <strong>Date:</strong>${this._formatDate(r.createdat)}
                </div>
              ` : ''}
          <div class="tooltip-row"><strong>Commit Number:</strong>${r.commit_number}</div>
          <div class="tooltip-row"><strong>Value:</strong>${this._formatTooltipValue(r.val)}</div>
        </div>

        <!-- Section 2: Commit Info -->
        <div class="tooltip-section">
          <div class="tooltip-row">
            <strong>Author:</strong>
            ${r.author ? (0, _lit.html)`<span class="truncate">${r.author.split('(')[0]}</span>` : (0, _lit.html)`<span class="skeleton" style="width: 80px; height: 12px;"></span>`}
          </div>
          <div class="tooltip-row">
            <strong>Message:</strong>
            ${r.message ? (0, _lit.html)`<span class="wrap">${r.message}</span>` : (0, _lit.html)`<span class="skeleton" style="width: 180px; height: 12px;"></span>`}
          </div>
          ${r.hash ? (0, _lit.html)`
                <div class="tooltip-row">
                  <strong>Commit:</strong>
                  <a href="${r.url}" target="_blank"> ${r.hash.substring(0, 8)} </a>
                </div>
              ` : ''}
        </div>
        ${(()=>{
            var _this_regressions_s_id;
            const regression = (_this_regressions_s_id = this.regressions[s.id]) === null || _this_regressions_s_id === void 0 ? void 0 : _this_regressions_s_id[r.commit_number];
            if (regression) {
                return (0, _lit.html)`
              <div class="tooltip-row">
                <strong>Anomaly:</strong> ${regression.is_improvement ? 'Improvement' : 'Regression'}
              </div>
              <div class="tooltip-row">
                <strong>Anomaly Range:</strong>
                <commit-range-sk id="anomaly-commit-range-link"></commit-range-sk>
              </div>
              <div class="tooltip-row">
                <strong>Median:</strong> ${(0, _anomaly.formatNumber)(regression.median_after)}
              </div>
              <div class="tooltip-row">
                <strong>Previous:</strong> ${(0, _anomaly.formatNumber)(regression.median_before)}
                [${this._anomalyChange(regression)}%]
              </div>
              ${regression.multiplicity ? (0, _lit.html)`
                    <div class="tooltip-row">
                      <strong>Multiplicity:</strong> ${regression.multiplicity}
                    </div>
                  ` : ''}
              ${regression.is_legacy ? (0, _lit.html)`
                    <div class="tooltip-row">
                      <strong>Legacy anomaly</strong>
                    </div>
                  ` : ''}
              ${regression.bisect_ids && regression.bisect_ids.length > 0 ? (0, _lit.html)`
                    <div class="tooltip-row">
                      <strong>Pinpoint:</strong>
                      <span>
                        ${regression.bisect_ids.map((id, index)=>(0, _lit.html)`<a
                                href="https://pinpoint-dot-chromeperf.appspot.com/job/${id}"
                                target="_blank"
                                >${id}</a
                              >${index < regression.bisect_ids.length - 1 ? (0, _lit.html)`<br />` : ''}`)}
                      </span>
                    </div>
                  ` : ''}
              ${regression.bugs && regression.bugs.length > 0 ? (0, _lit.html)`
                    <div class="tooltip-row">
                      <strong>Bug ID:</strong>
                      <span>
                        ${regression.bugs.map((bug, index)=>(0, _lit.html)`
                            ${(0, _anomaly.formatBug)(this.bug_host_url, Number(bug.bug_id))}
                            ${index < regression.bugs.length - 1 ? ', ' : ''}
                          `)}
                      </span>
                      <close-icon-sk
                        id="unassociate-bug-button"
                        @click=${()=>this.unassociateBug(s.originalId || s.id, regression)}>
                      </close-icon-sk>
                    </div>
                  ` : ''}
              <div class="tooltip-row">
                <triage-menu-sk
                  id="tooltip-triage-menu"
                  .anomalies=${[
                    regression
                ]}
                  .traceNames=${[
                    s.originalId || s.id
                ]}
                  .nudgeList=${this._nudgeList}
                  ?hidden=${regression.bugs && regression.bugs.length > 0}>
                </triage-menu-sk>
              </div>
            `;
            }
            return '';
        })()}
        ${this.showPinpointButtons || this.showBisectButton ? (0, _lit.html)`
              <div class="tooltip-row">
                <strong>Pinpoint:</strong>
                <div class="buttons inline-buttons">
                  <button
                    id="bisect"
                    @click=${this.openBisectDialog}
                    ?hidden=${!this.showBisectButton}>
                    Bisect
                  </button>
                  <button
                    id="try-job"
                    @click=${this.openTryJobDialog}
                    ?hidden=${!this.showPinpointButtons}>
                    Request Trace
                  </button>
                </div>
              </div>
            ` : ''}
        ${(()=>{
            var _this_regressions_s_id;
            const regression = (_this_regressions_s_id = this.regressions[s.id]) === null || _this_regressions_s_id === void 0 ? void 0 : _this_regressions_s_id[r.commit_number];
            if (!regression) {
                return (0, _lit.html)`
              <div class="tooltip-row">
                <strong>User Issues:</strong>
                <div class="buttons inline-buttons">
                  <user-issue-sk
                    id="tooltip-user-issue-sk"
                    .bug_id=${0}
                    .trace_key=${this._debouncedTraceKey}
                    .commit_position=${this._debouncedCommitPosition}
                    .user_id=${this.user_id}>
                  </user-issue-sk>
                </div>
              </div>
            `;
            }
            return '';
        })()}
        <div class="tooltip-row">
          <strong>Point Range:</strong>
          <commit-range-sk id="tooltip-commit-range-link" .hashes=${this._tooltipHashes}>
          </commit-range-sk>
        </div>
        <div class="tooltip-row">
          <point-links-sk id="tooltip-point-links"></point-links-sk>
          ${(()=>{
            if (!this._linksLoading) return '';
            const commitRangeKeys = Array.from(new Set(this._getCommitRangeKeys().map((k)=>k.replace(/ Git.*/i, '').trim()).filter(Boolean)));
            const usefulLinksKeys = Array.from(new Set(this._getUsefulLinksKeys().map((k)=>k.trim()).filter(Boolean)));
            const allKeys = [
                ...commitRangeKeys,
                ...usefulLinksKeys
            ];
            const duplicateKeys = allKeys.filter((key, index)=>allKeys.indexOf(key) !== index);
            if (duplicateKeys.length > 0) {
                console.error('Duplicate keys found in subrepo and useful links:', duplicateKeys);
            }
            if (allKeys.length === 0) return '';
            return (0, _lit.html)`
              <div class="subrepo-skeleton">
                ${allKeys.map((k)=>(0, _lit.html)`
                    <div class="tooltip-row">
                      <strong>${k}:</strong>
                      <span class="skeleton" style="width: 120px; height: 12px;"></span>
                    </div>
                  `)}
              </div>
            `;
        })()}
        </div>
        ${((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.show_json_file_display) ? (0, _lit.html)`
              <div class="tooltip-row">
                <json-source-sk
                  id="json-source-sk"
                  .cid=${r.commit_number}
                  .traceid=${s.originalId || s.id}>
                </json-source-sk>
              </div>
            ` : ''}
        ${this.tooltipDiffs && this.processedSeries.length > 1 ? (()=>{
            const targetX = this._xAccessor(r);
            return (0, _lit.html)`
                <div class="diff-section">
                  <div class="diff-title">Diff vs other traces:</div>
                  ${this.processedSeries.map((os)=>{
                if (os.id === s.id) return '';
                let otherVal = null;
                let commitDistance = 0;
                let exactRow = null;
                let minDist = Infinity;
                for (const or of os.rows){
                    const dist = Math.abs(this._xAccessor(or) - targetX);
                    if (dist < minDist) {
                        minDist = dist;
                        exactRow = or;
                    } else if (this._xAccessor(or) > targetX) {
                        break;
                    }
                }
                if (exactRow) {
                    otherVal = exactRow.val;
                } else {
                    let closest = null;
                    let minDiff = Infinity;
                    for (const or of os.rows){
                        const diff = Math.abs(this._xAccessor(or) - targetX);
                        if (diff < minDiff) {
                            minDiff = diff;
                            closest = or;
                        }
                    }
                    if (closest) {
                        otherVal = closest.val;
                        commitDistance = minDiff;
                    }
                }
                if (otherVal !== null && otherVal !== 0) {
                    const myVal = r.val;
                    const diffY = myVal - otherVal;
                    const pctY = diffY / Math.abs(otherVal) * 100;
                    const color = diffY >= 0 ? '#4caf50' : '#e53935';
                    return (0, _lit.html)`
                        <div class="diff-row">
                          <div class="diff-trace-info">
                            <span
                              class="diff-color-swatch"
                              style="background-color: ${os.color};"></span>
                            <span
                              class="diff-trace-name"
                              title="${this.diffNamesMap.get(os.id) || os.id}">
                              ${this.diffNamesMap.get(os.id) || os.id}
                            </span>
                          </div>
                          <div class="diff-values">
                            <span class="diff-percent" style="color: ${color};">
                              ${diffY > 0 ? '+' : ''}${pctY.toFixed(1)}%
                            </span>
                            ${commitDistance > 0 ? (0, _lit.html)`
                                  <span class="diff-distance" title="${commitDistance} units away">
                                    (±${commitDistance})
                                  </span>
                                ` : ''}
                          </div>
                        </div>
                      `;
                }
                return '';
            })}
                </div>
              `;
        })() : ''}
      </div>
      <pinpoint-dialog-sk id="pinpoint-dialog-sk"></pinpoint-dialog-sk>
    `;
    }
    constructor(...args){
        super(...args);
        this.hoveredPoint = null;
        this.dateMode = false;
        this.yAxisLabel = 'score';
        this.bug_host_url = window.perf ? window.perf.bug_host_url : '';
        this.regressions = {};
        this.diffNamesMap = new Map();
        this.tooltipDiffs = false;
        this.processedSeries = [];
        this.showBisectButton = false;
        this.showPinpointButtons = false;
        this.canvasWidth = 0;
        this.canvasHeight = 0;
        this._lastLoadedPoint = null;
        this._debouncedTraceKey = '';
        this._debouncedCommitPosition = 0;
        this.user_id = '';
        this._tooltipHashes = null;
        this._linksLoading = false;
        this._nudgeList = null;
        this._linksTimeout = null;
        this._debounceTimer = null;
        this._handlers = {};
    }
}, (()=>{
    _TraceChartTooltipSk.styles = (0, _lit.css)`
    .hover-tooltip {
      position: absolute;
      background: var(--surface);
      backdrop-filter: blur(8px);
      border: 1px solid color-mix(in srgb, var(--on-surface) 10%, transparent);
      color: var(--on-surface);
      padding: 12px 16px;
      border-radius: 8px;
      font-size: 12px;
      pointer-events: auto;
      z-index: 10;
      box-shadow: 0 10px 25px -5px var(--transparent-overlay);
      max-width: 320px;
      font-family: 'JetBrains Mono', monospace;
    }

    .hover-tooltip a {
      color: var(--primary);
      text-decoration: none;
    }

    .hover-tooltip a:hover {
      text-decoration: underline;
      color: var(--primary-variant);
    }

    .tooltip-row {
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      gap: 8px;
    }

    .tooltip-row strong {
      color: var(--on-surface);
      font-weight: 600;
      min-width: 60px;
      opacity: 0.6;
    }

    .tooltip-section {
      margin-bottom: 8px;
      padding-bottom: 8px;
      border-bottom: 1px solid color-mix(in srgb, var(--on-surface) 10%, transparent);
    }

    .tooltip-section:last-child {
      border-bottom: none;
    }

    .color-indicator {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    .truncate {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }

    .wrap {
      white-space: normal;
      overflow-wrap: break-word;
    }

    .regression {
      color: var(--negative);
    }

    .improvement {
      color: var(--positive);
    }

    .inline-buttons {
      display: inline-block;
      margin-left: 4px;
    }

    .diff-section {
      margin-bottom: 8px;
      font-size: 13px;
      border-top: 1px solid color-mix(in srgb, var(--on-surface) 10%, transparent);
      padding-top: 6px;
    }

    .diff-title {
      color: var(--on-surface-variant);
      margin-bottom: 4px;
      font-weight: 500;
    }

    .diff-row {
      display: flex;
      align-items: center;
      margin-bottom: 2px;
      justify-content: space-between;
    }

    .diff-trace-info {
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-right: 8px;
    }

    .diff-color-swatch {
      width: 8px;
      height: 8px;
      border-radius: 2px;
      margin-right: 6px;
      flex-shrink: 0;
    }

    .diff-trace-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .diff-values {
      display: flex;
      align-items: center;
    }

    .diff-percent {
      font-weight: 500;
      flex-shrink: 0;
    }

    .diff-distance {
      color: var(--on-surface-variant);
      font-size: 11px;
      margin-left: 6px;
      white-space: nowrap;
    }

    .skeleton {
      display: inline-block;
      background: var(--outline);
      border-radius: 4px;
      animation: pulse 1.5s infinite;
    }

    .subrepo-skeleton {
      border-top: 1px solid color-mix(in srgb, var(--on-surface) 10%, transparent);
      padding-top: 8px;
      margin-top: 8px;
      width: 100%;
    }

    @keyframes pulse {
      0% {
        opacity: 0.6;
      }

      50% {
        opacity: 0.3;
      }

      100% {
        opacity: 0.6;
      }
    }

    triage-menu-sk button {
      height: var(--perf-button-height);
      min-width: var(--perf-button-min-width);
      padding: var(--perf-button-padding, 0 8px);
      font-size: var(--perf-button-font-size);
      text-transform: none;
      border-radius: var(--perf-button-border-radius);
      border: solid 1px var(--outline);
      background: var(--surface);
      color: var(--primary);
      font-family: var(--font);
      cursor: pointer;
      margin: var(--perf-button-margin);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      box-shadow: none;
      text-decoration: none;
      line-height: normal;
    }

    triage-menu-sk button:hover {
      background-color: var(--surface-1dp);
    }

    toast-sk {
      display: flex;
      visibility: hidden;
      position: fixed;
      left: auto;
      bottom: 0;
      color: var(--on-background);
      background: var(--background);
      fill: var(--on-background);
      padding: 10px 15px;
      opacity: 0;
      z-index: 20;
    }

    toast-sk[shown] {
      visibility: visible;
      opacity: 1;
      bottom: 30px;
      color: var(--on-background);
      background: var(--background);
      fill: var(--background);
      width: auto;
      max-width: 1000px;
    }

    triage-menu-sk #ignore_toast {
      background-color: var(--background);
      color: var(--on-background);
    }

    close-icon-sk#unassociate-bug-button {
      fill: var(--negative);
      cursor: pointer;
      height: 18px;
      width: 18px;
      margin-left: 4px;
      vertical-align: middle;
    }
  `;
})(), _TraceChartTooltipSk);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", Object)
], TraceChartTooltipSk.prototype, "hoveredPoint", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], TraceChartTooltipSk.prototype, "dateMode", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    })
], TraceChartTooltipSk.prototype, "yAxisLabel", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    })
], TraceChartTooltipSk.prototype, "bug_host_url", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", Object)
], TraceChartTooltipSk.prototype, "regressions", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", typeof Map === "undefined" ? Object : Map)
], TraceChartTooltipSk.prototype, "diffNamesMap", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], TraceChartTooltipSk.prototype, "tooltipDiffs", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], TraceChartTooltipSk.prototype, "processedSeries", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], TraceChartTooltipSk.prototype, "showBisectButton", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], TraceChartTooltipSk.prototype, "showPinpointButtons", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    })
], TraceChartTooltipSk.prototype, "canvasWidth", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    })
], TraceChartTooltipSk.prototype, "canvasHeight", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], TraceChartTooltipSk.prototype, "_lastLoadedPoint", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], TraceChartTooltipSk.prototype, "_debouncedTraceKey", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Number)
], TraceChartTooltipSk.prototype, "_debouncedCommitPosition", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    })
], TraceChartTooltipSk.prototype, "user_id", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], TraceChartTooltipSk.prototype, "_tooltipHashes", void 0);
_ts_decorate([
    (0, _decorators.state)()
], TraceChartTooltipSk.prototype, "_linksLoading", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], TraceChartTooltipSk.prototype, "_nudgeList", void 0);
TraceChartTooltipSk = _ts_decorate([
    (0, _decorators.customElement)('trace-chart-tooltip-sk')
], TraceChartTooltipSk);
